<p-tabView class="holding-tabs" *ngIf="network && filters">
  <p-tabPanel header="Professionals">
    <!--<app-professionals-table *ngIf="filters" #professionalsTable [filters]="filters"></app-professionals-table>-->
    <app-professionals-multiple [network]="network"></app-professionals-multiple>
  </p-tabPanel>
  <p-tabPanel header="Structure">
    <app-network-structure [network]="network"></app-network-structure>
  </p-tabPanel>
</p-tabView>
